import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initAppCheckOnce } from './lib/appCheck';
import { generateDeviceKeypair } from './lib/payloadCrypto';
import './index.css';

initAppCheckOnce();
generateDeviceKeypair();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
